import React from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
/* eslint-disable css-modules/no-unused-class -- a shared stylesheet; each part uses its own slice of it */
import styles from './Panel.module.scss';
/* eslint-enable css-modules/no-unused-class */

export interface PanelBodyProps {
  className?: string;
  /** Puts the children in one column with a 14px gap. */
  stack?: boolean;
  /** Removes the padding, for content that runs to the edges of the box (a table, a list of rows). */
  flush?: boolean;
  children: React.ReactNode;
}

/** The padded body under a PanelHead. Its sides line up with the head title. */
const PanelBodyComponent: React.FC<PanelBodyProps> = ({ className, stack = false, flush = false, children }) => (
  <div className={clsx(styles.body, stack && styles.stack, flush && styles.flush, className)}>{children}</div>
);

export const PanelBody = TypedMemo(PanelBodyComponent);
